
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class CtvBasvuruAPI extends BaseAPI {


  constructor () {
    const baseUrl = environment.API_URL + "CtvBasvuruSave";
    super(baseUrl);
  }


  saveCtvBasvuruSave(request: CtvBasvuruRequest){
    
    return this.post("", request, true);
   
  }

}
export default new CtvBasvuruAPI();
class CtvBasvuruRequest {
  basvuruTuruId: number;
  sicilKodu: number;
  mahalleKodu: number;
  caddeSokakKodu: number;
  kapiNo: number;
  altKapiNo?: string;
  daireNo?: number;
  altDaireNo?: string;
  blokKatNo?: string;
  siteApartmanAdi?: string;
  pafta?: string;
  ada?: number;
  parsel?: number;
  isyeriAcmaTarihi?: string;
  faaliyetKodu?: number;
  kullanimSekliKodu?: number;
  kriterKodu?: number;
  m2?: number;
  ogrenciSayisi?: number;
  koltukSayisi?: number;
  personelSayisi?: number;
  yatakSayisi?: number;
  grup?: number;
  derece?: number;
  aciklama?: string;
  kaloriferliMi?: string;
  captchaToken?: string;


  constructor(
      basvuruTuruId: number,
      sicilKodu: number,
      mahalleKodu: number,
      caddeSokakKodu: number,
      kapiNo: number,
      altKapiNo?: string,
      daireNo?: number,
      altDaireNo?: string,
      blokKatNo?: string,
      siteApartmanAdi?: string,
      pafta?: string,
      ada?: number,
      parsel?: number,
      isyeriAcmaTarihi?: string,
      faaliyetKodu?: number,
      kullanimSekliKodu?: number,
      kriterKodu?: number,
      m2?: number,
      ogrenciSayisi?: number,
      koltukSayisi?: number,
      personelSayisi?: number,
      yatakSayisi?: number,
      ctvGrup?: number,
      ctvDerece?: number,
      aciklama?: string,
      kaloriferliMi?: string,
      captchaToken?: string
  ) {
      this.basvuruTuruId = basvuruTuruId;
      this.sicilKodu = sicilKodu;
      this.mahalleKodu = mahalleKodu;
      this.caddeSokakKodu = caddeSokakKodu;
      this.kapiNo = kapiNo;
      this.altKapiNo = altKapiNo;
      this.daireNo = daireNo;
      this.altDaireNo = altDaireNo;
      this.blokKatNo = blokKatNo;
      this.siteApartmanAdi = siteApartmanAdi;
      this.pafta = pafta;
      this.ada = ada;
      this.parsel = parsel;
      this.isyeriAcmaTarihi = isyeriAcmaTarihi;
      this.faaliyetKodu = faaliyetKodu;
      this.kullanimSekliKodu = kullanimSekliKodu;
      this.kriterKodu = kriterKodu;
      this.m2 = m2;
      this.ogrenciSayisi = ogrenciSayisi;
      this.koltukSayisi = koltukSayisi;
      this.personelSayisi = personelSayisi;
      this.yatakSayisi = yatakSayisi;
      this.grup = ctvGrup;
      this.derece = ctvDerece;
      this.aciklama = aciklama;
      this.kaloriferliMi = kaloriferliMi;
      this.captchaToken = captchaToken;
  }
}

export { CtvBasvuruRequest };
/*
*/



